import React from "react";
import WebSolTemplate from "./WebSolTemplate";
import Slider from "../../Slider/Slider";

export default function SmallBusinessWeb() {
  return (
    <>
      <div
        class="inner-page"
        id="website-design-bg"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div
                class="inner_content"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h1> Small Business Website</h1>
                <div aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <a href="index.html">
                        <i class="ri-home-4-line"></i>Home
                      </a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Small Business Website
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section
        class="website-banner section"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <div class="container">
          <div class="row align-items-center g-4">
            <div class="col-md-7">
              <div class="heading">
                <h3>Small Business Website</h3>
                <p>
                  Welcome to Adret software, your partner in transforming your
                  small business into a digital success story. In the
                  ever-evolving landscape of the internet, a well-crafted web
                  presence is not just a luxury but a necessity for small
                  businesses aiming to thrive. Our Small Business Web Services
                  are meticulously designed to provide you with a cost-effective
                  and dynamic online platform that can make a substantial impact
                  on your growth and customer engagement.
                </p>
                <div class="btn_sec">
                  <a href="#" class="btn1 btn_gap">
                    Quick Enquiry
                  </a>
                  <a href="#" class="btn3">
                    Small Business Portfolio
                  </a>
                </div>
              </div>
            </div>

            <div class="col-md-5">
              <img
                src="https://www.webguru-india.com/assets/images/small-business-website-design-thumbnails.jpg"
                class="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <section
        class="section bg_color1"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <div class="container">
          <h2 class="section-title">
            End-to-End Small Business Website Solutions
          </h2>
          <p class="section-subtitle">
            Craft Your Small Business Website with a Leading Web Development
            Agency
          </p>

          <p>
            Welcome to [Your Company Name], where we redefine the landscape of
            digital success with our comprehensive and End-to-End Small Business
            Website Solutions. In today's dynamic business environment, a robust
            online presence is fundamental, and our suite of services is
            designed to cater to every facet of your digital journey.Our process
            begins with an in-depth analysis of your small business objectives,
            target audience, and market dynamics. We collaborate with you to
            develop a strategic roadmap that aligns your small business web
            goals with industry trends and user expectations.
            <br />
          </p>
        </div>

        <div class="details-website">
          <div class="container py-5">
            <div class="row">
              <div class="col-md-6" data-aos="fade-up" data-aos-duration="1500">
                <div class="py-5">
                  <div class="d-flex align-items-center">
                    <i class="ri-pages-line icon-color"></i>
                    <p class="subtitle">Small Business Development</p>
                  </div>
                  <p>
                    When establishing a small business, a website is crucial for
                    creating a digital presence. In today's competitive market,
                    a compelling online presence from the start is essential.
                    Our process involves in-depth research of your niche,
                    understanding challenges, and spotting opportunities. This
                    guides our strategic plan to craft an appealing website
                    tailored to your small business requirements and objectives.
                  </p>
                </div>
              </div>

              <div class="col-md-6" data-aos="fade-up" data-aos-duration="1500">
                <div class="py-5">
                  <div class="d-flex align-items-center">
                    <i class="ri-line-chart-line icon-color"></i>
                    <p class="subtitle">Small Business Web Development</p>
                  </div>
                  <p>
                    Our Small Business Web Development services are designed to
                    meet the unique needs of small enterprises. We understand
                    that your website is the digital face of your small
                    business, and we're committed to creating a seamless,
                    visually appealing, and highly functional online experience.
                  </p>
                </div>
              </div>

              <div class="col-md-6" data-aos="fade-up" data-aos-duration="1500">
                <div class="py-5">
                  <div class="d-flex align-items-center">
                    <i class="ri-shopping-cart-line icon-color"></i>
                    <p class="subtitle">eCommerce for Small Business</p>
                  </div>
                  <p>
                    Converting casual online visitors into loyal customers is
                    crucial for small businesses. As top web designers, we can
                    build an optimized online store using popular platforms and
                    frameworks. You can choose from various CMS options
                    (Shopify, BigCommerce, Magento, OpenCart, WordPress) or
                    extensive custom programming for shopping cart development
                    as per your small business requirements. We also provide
                    services for developing impressive Marketplace, both B2B &
                    B2C Structures.
                  </p>
                </div>
              </div>

              <div class="col-md-6" data-aos="fade-up" data-aos-duration="1500">
                <div class="py-5">
                  <div class="d-flex align-items-center">
                    <i class="ri-pencil-ruler-fill icon-color"></i>
                    <p class="subtitle">Corporate Website for Small Business</p>
                  </div>
                  <p>
                    High-end professionalism, impressive User Interface, easy
                    accessibility - a corporate website for small businesses has
                    to reflect everything. As a trusted web design agency, we
                    craft innovative and secure websites tailored for small
                    enterprises all around the world. Adept with technical
                    skill, extensive experience, consistent communication with
                    the client, and attention to every detail, we ensure quality
                    service within a quick turnaround time.
                  </p>
                </div>
              </div>
            </div>

            <div class="btn_sec">
              <a href="#" class="btn1 btn_gap">
                Our Projects
              </a>
              <a href="#" class="btn3">
                Our Services
              </a>
            </div>
          </div>
        </div>
      </section>

      <section
        class="our_clientele_sec"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <div
                class="heading row_gap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h2>Our Clients</h2>
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-6 g-2 row-cols-md-5 row-cols-sm-4 row-cols-3 justify-content-center align-items-center ">
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-1.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-2.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-3.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-4.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-5.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-6.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-7.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-8.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-9.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-10.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-11.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/client-12.webp"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Slider />

      <section
        class="our_clientele_sec"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <div
                class="heading row_gap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h2>Tools & Technologies </h2>
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-6 g-2 row-cols-md-5 row-cols-sm-4 row-cols-3 justify-content-center align-items-center ">
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-1.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-2.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-3.jpg" class="img-fluid" alt="" />
              </div>
            </div>

            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-4.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-5.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-6.jpg" class="img-fluid" alt="" />
              </div>
            </div>

            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-7.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-8.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-9.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-10.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-11.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-12.jpg" class="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="wes d-lg-block d-none bg_color">
        <div class="container">
          <h2 class="section-title-2 text-center">
            Our Small Business Website Development Services
          </h2>
          <p class="section-subtitle text-center">
            Our Small Business Website Development services provide a tailored
            approach to building dynamic and feature-rich websites. From
            crafting user-friendly interfaces to implementing secure server-side
            functionalities, we cover every aspect of the development lifecycle.
          </p>
          <ul class="nav nav-tabs nav-justified mb-3 " id="ex1" role="tablist">
            <li class="nav-item mr-5" role="presentation">
              <a
                class="nav-link active"
                id="ex3-tab-1"
                data-bs-toggle="tab"
                href="#ex3-tabs-1"
                role="tab"
                aria-controls="ex3-tabs-1"
                aria-selected="true"
              >
                Frontend Development
              </a>
            </li>
            <li class="nav-item mr-5" role="presentation">
              <a
                class="nav-link"
                id="ex3-tab-2"
                data-bs-toggle="tab"
                href="#ex3-tabs-2"
                role="tab"
                aria-controls="ex3-tabs-2"
                aria-selected="false"
              >
                Backend Development
              </a>
            </li>
            <li class="nav-item mr-5" role="presentation">
              <a
                class="nav-link"
                id="ex3-tab-3"
                data-bs-toggle="tab"
                href="#ex3-tabs-3"
                role="tab"
                aria-controls="ex3-tabs-3"
                aria-selected="false"
              >
                API & Integration
              </a>
            </li>
            <li class="nav-item mr-5" role="presentation">
              <a
                class="nav-link"
                id="ex3-tab-4"
                data-bs-toggle="tab"
                href="#ex3-tabs-4"
                role="tab"
                aria-controls="ex3-tabs-4"
                aria-selected="false"
              >
                Database
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link"
                id="ex3-tab-5"
                data-bs-toggle="tab"
                href="#ex3-tabs-5"
                role="tab"
                aria-controls="ex3-tabs-5"
                aria-selected="false"
              >
                Version Control
              </a>
            </li>
          </ul>

          <div class="tab-content" id="ex2-content">
            <div
              class="tab-pane fade show active"
              id="ex3-tabs-1"
              role="tabpanel"
              aria-labelledby="ex3-tab-1"
            >
              <div class="d-flex align-items-center">
                <i class="ri-pencil-ruler-2-line icon-color icon-style"></i>
                <h4 class="mb-0 ml-2">Frontend Development</h4>
              </div>
              <p>
                Welcome to our small business website Frontend Development
                services, where we specialize in creating visually appealing and
                responsive user interfaces. We focus on enhancing user
                experience and engagement for your website visitors.
              </p>
            </div>
            <div
              class="tab-pane fade"
              id="ex3-tabs-2"
              role="tabpanel"
              aria-labelledby="ex3-tab-2"
            >
              <div class="d-flex align-items-center">
                <i class="ri-terminal-window-line icon-color icon-style"></i>
                <h4 class="mb-0 ml-2">Backend Development</h4>
              </div>
              <p>
                Our small business website Backend Development services ensure a
                robust and scalable web solution. Using top-notch technologies
                like Node.js, Symfony, Laravel, CakePHP, and CodeIgniter, we
                focus on creating a backend that is efficient and built to
                perfection for your business growth.
              </p>
            </div>
            <div
              class="tab-pane fade"
              id="ex3-tabs-3"
              role="tabpanel"
              aria-labelledby="ex3-tab-3"
            >
              <div class="d-flex align-items-center">
                <img
                  src="assets/image/api.png"
                  class="icon-color icon-style p-2"
                  alt=""
                />
                <h4 class="mb-0 ml-2">API Development & Integration</h4>
              </div>
              <p>
                Our API Development & Integration services focus on creating
                secure custom REST frameworks for small business websites. We
                ensure a robust and flexible toolkit for creating custom web
                APIs with a three-level protocol to ensure REST API security.
              </p>
            </div>
            <div
              class="tab-pane fade"
              id="ex3-tabs-4"
              role="tabpanel"
              aria-labelledby="ex3-tab-4"
            >
              <div class="d-flex align-items-center">
                <img
                  src="assets/image/db.png"
                  class="icon-color icon-style p-3"
                  alt=""
                />
                <h4 class="mb-0 ml-2">Database</h4>
              </div>
              <p>
                Our small business website Database services ensure that your
                application’s data is secure and easily accessible. We work with
                various relational and non-relational database management
                systems including PostgreSQL, MySQL, and NoSQL databases
                (MongoDB, Apache Cassandra). Our expertise includes Database
                Middleware for interoperability and performance scaling.
              </p>
            </div>
            <div
              class="tab-pane fade"
              id="ex3-tabs-5"
              role="tabpanel"
              aria-labelledby="ex3-tab-5"
            >
              <div class="d-flex align-items-center">
                <img
                  src="assets/image/version-control.png"
                  class="icon-color icon-style img-fluid p-3"
                  alt=""
                />
                <h4 class="mb-0 ml-2">Version Control</h4>
              </div>
              <p>
                Our Version Control services help manage changes to the source
                code over time. We organize codes for small business apps,
                keeping track of modifications and ensuring a glitch-free app
                development process. We prefer Bitbucket and GitHub to support
                source control needs.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
